var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5743_1534)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35554 0.0625C1.05501 0.0625 0 1.08539 0 2.34558V29.6522C0 30.9125 1.05514 31.9345 2.35554 31.9345H29.5165C30.8175 31.9345 31.872 30.9124 31.872 29.6518V2.34558C31.872 1.08539 30.8175 0.0625 29.5165 0.0625H2.35554ZM9.68564 12.386V26.7349H4.91629V12.386H9.68564ZM10 7.94845C10 9.32542 8.96478 10.4272 7.30196 10.4272L7.30159 10.4271H7.27071C5.67002 10.4271 4.63517 9.3253 4.63517 7.94833C4.63517 6.54011 5.70127 5.46904 7.33359 5.46904C8.96478 5.46904 9.96888 6.54011 10 7.94845ZM17.0945 26.7349H12.3255L12.3254 26.7354C12.3254 26.7354 12.388 13.7326 12.3258 12.3865H17.0949V14.4175C17.7289 13.44 18.8635 12.0496 21.3932 12.0496C24.531 12.0496 26.8836 14.1005 26.8836 18.5077V26.7349H22.1147V19.0595C22.1147 17.1303 21.4241 15.8146 19.6988 15.8146C18.381 15.8146 17.5962 16.7019 17.2516 17.5591C17.1256 17.865 17.0945 18.2944 17.0945 18.7227V26.7349Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5743_1534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.ea43d582dc071900df59fe4da44c718e.svg";
export { ForwardRef as ReactComponent };